export function setCacheSelectedRAGIds(ids: number[]) {
    localStorage.setItem('selectedRAGIds', JSON.stringify(ids));
}

export function getCacheSelectedRAGIds() {
    const ret = localStorage.getItem('selectedRAGIds');
    if (!ret) return null
    try {
        return JSON.parse(ret) as number[]
    }
    catch {
        localStorage.clear()
        return null
    }
}

export function syncCacheSelectedRAGIds(availableRAGIds: number[]) {
    const selectedRAGIds = getCacheSelectedRAGIds()
    if (!selectedRAGIds) return

    const filtered = selectedRAGIds.filter((v) => availableRAGIds.includes(v))
    setCacheSelectedRAGIds(filtered)
}